exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tag_3[data-v-7ba50fca] {\r\n  display : inline-block;\r\n  margin : 4px;\n}\n.tag_2[data-v-7ba50fca] {\r\n  text-overflow : ellipsis;\r\n  white-space : nowrap;\r\n  margin : 0 1px;\n}\n.tag_1[data-v-7ba50fca] {\r\n  padding : 1px 5px;\r\n\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-radius: 4px;\r\n  background-color: #f4f4f5;\r\n  border-color: #e9e9eb;\r\n  color: #909399;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba50fca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketTag.vue
// module id = 739
// module chunks = 75